// extracted by mini-css-extract-plugin
export var orderSummary = "_s1-0";
export var showMoreLessButton = "_s1-1";